export const isEmptyLibrariesQuery = (isSuccess: boolean, libraryCount: number): boolean =>
  isSuccess && libraryCount === 0
